module.exports = __webpack_public_path__ + "img/img_Colleges1.62bb9eb9.png";